import React from 'react'
import { Link as ReactLink }from 'react-router-dom'
import Link from '@mui/material/Link'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'

export default function EventWeb() {
    return (
        <Box 
            display="flex" 
            flexDirection="column" 
            alignItems="center" 
            justifyContent="column" 
            // sx={{ p: 10}}
            // style={{ width:'100%', height: '100vh' }}
        >
            <Box
                display="flex" 
                flexDirection="column" 
                alignItems="left" 
                justifyContent="flex-start" 
                sx={{ p: 7 }}
                style={{ width: '100%', height: '317px', backgroundImage: 'url("/images/events/banner_top.jpg")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
            >
                <ReactLink to='/'>
                    <Box style={{ paddingBottom: '50px' }}>
                        <img alt="logo" src="/images/events/home.png" />
                    </Box>
                </ReactLink>
                <Box display="flex" flexDirection="row" >
                    <span style={{color: 'white', fontSize: '28px', paddingRight: '10px'}}>Nice to meet u,</span>
                    <img height="28px" alt="logo" src="/images/events/logo_white.png" />
                </Box>
                <span style={{color: 'white', fontSize: '70px', fontWeight: "bold"}}>스타터 작가</span>

            </Box>
            <Box
                display="flex" 
                flexDirection="column" 
                sx={{ m: 9}} 
            >
                <Box 
                    display="flex" 
                    flexDirection="column" 
                    alignItems="center" 
                    justifyContent="center" 
                    style={{ width: '1560px', height: '210px', backgroundImage: 'url("/images/events/banner_top2.jpg")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
                >
                    <img alt="logo" src="/images/events/logo_square_white.png" />
                </Box>
            </Box>
            <Box
                display="flex" 
                flexDirection="column" 
                alignItems="center" 
                justifyContent="center" 
                sx={{ pt: 7 }}
            >
                <span style={{ fontSize: '26px', }}>Welcome, MOOA!</span>
                <span style={{ fontSize: '35px', fontWeight: "bold", }}>스타터 작가란 무엇인가요?</span>
                <span style={{ fontSize: '20px', paddingTop: '20px'}}>스타터 작가란, 모아의 시작을 함께 할 작가들을 뜻합니다.</span>
                <span style={{ fontSize: '20px', }}>모아 출시와 동시에 작품이 업로드되고, 앱의 메인과 공식 SNS에 소개가 될 예정입니다.</span>

            </Box>
            <Box
                display="flex" 
                flexDirection="column" 
                alignItems="left" 
                justifyContent="center" 
                style={{ backgroundColor: '#F2F2F2', width: '1560px', marginTop: '30px', borderRadius: '10px' }}
                sx={{ p: 7 }}
            >
                <Box
                    display="flex" 
                    flexDirection="row" 
                    alignItems="center" 
                    justifyContent="left" 
                    sx={{ pl: 40 }}
                >
                    <img alt="logo" src="/images/events/number_1.png" />
                    <span style={{ fontSize: '26px', paddingLeft: '15px'}}>앱 출시일이 언제인가요?</span>
                </Box>
                <Box
                    display="flex" 
                    flexDirection="column" 
                    alignItems="left" 
                    justifyContent="center" 
                    sx={{ pl: 90 }}
                >
                    <span style={{ fontSize: '20px', paddingTop: '30px', }}>- 6월 10일 출시 예정입니다.</span>
                    <span style={{ fontSize: '15px', color: '#707070', paddingBottom: '40px', }}>* 내부 사정에 의해 변동될 수 있습니다. 변동 시 개별 연락을 드릴 예정입니다.</span>
                </Box>
                <Divider sx={{ height: 2, m: 1, marginLeft: '2%', marginRight: '2%' }} orientation="vertical" style={{ background: '#B7B7B7' }} />
                <Box
                    display="flex" 
                    flexDirection="row" 
                    alignItems="center" 
                    justifyContent="left" 
                    sx={{ pl: 40, pt: 7 }}
                >
                    <img alt="logo" src="/images/events/number_2.png" />
                    <span style={{ fontSize: '26px', paddingLeft: '15px'}}>모집인원이 어떻게 되나요?</span>
                </Box>
                <Box
                    display="flex" 
                    flexDirection="column" 
                    alignItems="left" 
                    justifyContent="center" 
                    sx={{ pl: 90 }}
                >
                    <span style={{ fontSize: '20px', paddingTop: '30px', paddingBottom: '40px', }}>- 50명 내외로 선발될 예정입니다.</span>
                </Box>
                <Divider sx={{ height: 2, m: 1, marginLeft: '2%', marginRight: '2%' }} orientation="vertical" style={{ background: '#B7B7B7' }} />
                <Box
                    display="flex" 
                    flexDirection="row" 
                    alignItems="center" 
                    justifyContent="left" 
                    sx={{ pl: 40, pt: 7 }}
                >
                    <img alt="logo" src="/images/events/number_3.png" />
                    <span style={{ fontSize: '26px', paddingLeft: '15px'}}>필요한 정보는 어떤게 있나요?</span>
                </Box>
                <Box
                    display="flex" 
                    flexDirection="column" 
                    alignItems="left" 
                    justifyContent="center" 
                    sx={{ pl: 90 }}
                >
                    <Box
                        display="flex" 
                        flexDirection="row" 
                        alignItems="left" 
                        justifyContent="left" 
                        sx={{ pt: 5 }}
                    >
                        <span style={{ fontSize: '20px', }}>- 이름, 연락처,</span>
                        <span style={{ fontSize: '20px', color: '#707070', }}>&nbsp;홍보 희망 계정 (선택)</span>
                    </Box>
                    <span style={{ fontSize: '20px', }}>- 업로드 희망 작품 정보</span>
                    <span style={{ fontSize: '18px', color: '#707070', }}>[이미지, 작품명, 재료, 작품 규격, 작품 설명, 작품 유형]</span>
                </Box>
            </Box>
            <Box
                display="flex" 
                flexDirection="column" 
                alignItems="center" 
                justifyContent="center" 
                sx={{ pt: 20 }}
            >
                <span style={{ fontSize: '26px', fontWeight: "bold", }}>스타터 작가가 되면...</span>
            </Box>
            <Box
                display="flex" 
                flexDirection="row" 
                alignItems="cnter" 
                justifyContent="space-between" 
                style={{ width: '1560px', marginTop: '50px', borderRadius: '10px', marginBottom: '220px'}}
            >
                <Box
                    display="flex" 
                    flexDirection="column" 
                    alignItems="cnter" 
                    justifyContent="center" 
                >
                    <img alt="logo" src="/images/events/square_1.png" />
                    <span style={{ fontSize: '20px', textAlign: 'center', paddingTop: '20px' }}>모아 앱의 메인화면에 소개</span>
                </Box>
                <Box
                    display="flex" 
                    flexDirection="column" 
                    alignItems="cnter" 
                    justifyContent="center" 
                >
                    <img alt="logo" src="/images/events/square_2.png" />
                    <span style={{ fontSize: '20px', textAlign: 'center', paddingTop: '20px' }}>인스타 공식 계정에 소개</span>
                </Box>
                <Box
                    display="flex" 
                    flexDirection="column" 
                    alignItems="cnter" 
                    justifyContent="center" 
                >
                    <img alt="logo" src="/images/events/square_3.png"/>
                    <span style={{ fontSize: '20px', textAlign: 'center', paddingTop: '20px' }}>온·오프라인 전시 우선선정</span>
                </Box>
                <Box
                    display="flex" 
                    flexDirection="column" 
                    alignItems="cnter" 
                    justifyContent="center" 
                >
                    <img alt="logo" src="/images/events/square_4.png" />
                    <span style={{ fontSize: '20px', textAlign: 'center', paddingTop: '20px' }}>5만원・ 3만원・ 1만원 상품권 증정</span>
                </Box>
            </Box>
            <Link href="https://forms.gle/TtvW3akmdGNaDNpi6/" target='_blank' style={{ textDecoration: 'none', color: 'black' }}>
                <Box
                    display="flex" 
                    flexDirection="row" 
                    alignItems="center" 
                    justifyContent="center" 
                    style={{ width: '860px', height: '70px', border: '1px solid black', borderRadius: '50px' }}
                    sx={{ p: 5, boxShadow: 3 }}
                >
                    <span style={{ fontSize: '30px', fontWeight: 'bold' }}>스타터 작가 신청하러 가기</span>
                </Box>
            </Link>
            <Box style={{ width:'1920px', height: '700px', backgroundColor: '#353C46', marginTop: '100px' }}>
                <Box 
                    display="flex" 
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="space-between"
                    paddingLeft="10%"
                    paddingRight="10%"
                    paddingTop="300px"
                >
                    <img alt="logo" src="/images/mooa_logo_footer.png" width={'131'} height={'34'}/>
                    <span style={{color: '#ffffff', fontSize: '17px'}}>모두의 아트, 모아</span>
                </Box>
                <Divider sx={{ height: 2, m: 1, marginLeft: '10%', marginRight: '10%' }} orientation="vertical" style={{ background: '#B7B7B7' }} />
                <Box 
                    display="flex" 
                    flexDirection="row"
                    paddingLeft="10%"
                    paddingRight="10%"
                    paddingTop='50px'
                >
                    <span style={{color: '#B7B7B7', fontSize: '17px'}}>문의사항</span>
                    <span style={{color: '#B7B7B7', fontSize: '17px', paddingLeft: '10px'}}>oursartsmoah@gmail.com</span>
                </Box>
                <Box 
                    display="flex" 
                    flexDirection="row"
                    paddingLeft="10%"
                    paddingRight="10%"
                    paddingTop='20px'
                >
                    <span style={{color: '#B7B7B7', fontSize: '17px'}}>서울특별시 금천구 가산디지털1로 205-15, 1007호</span>
                    <span style={{color: '#B7B7B7', fontSize: '17px', paddingLeft: '10px'}}>사업자 등록번호: 515-81-56247</span>
                </Box>
                <Box 
                    display="flex" 
                    flexDirection="row"
                    paddingLeft="10%"
                    paddingRight="10%"
                    paddingTop='50px'
                >
                    <Link href="https://www.instagram.com/art___mooa/" target='_blank'>
                        <img alt="logo" src="/images/instagram_logo.png" width={'37'} height={'34'}/>
                    </Link>
                </Box>
                <Box 
                    display="flex" 
                    flexDirection="row"
                    paddingLeft="10%"
                    paddingRight="10%"
                    paddingTop='50px'
                >
                    <span style={{color: '#B7B7B7', fontSize: '17px'}}>©</span>
                    <span style={{color: '#B7B7B7', fontSize: '17px', paddingLeft: '5px'}}>MOOA</span>
                </Box>
            </Box>
        </Box>
    )
}
